import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { getRevealProps } from '../motion/scrollMotion';
import ScrollReveal from './ScrollReveal';
import { FaTag, FaBolt, FaArrowRight } from 'react-icons/fa';
import './CTASection.css';

const CTASection = () => {
  return (
    <ScrollReveal as="section" className="cta-section" variant="fadeUp">
      {/* Top Transition Gradient (White to Black) */}
      <div className="cta-top-transition"></div>

      {/* Shooting Stars Background */}
      <div className="shooting-stars-bg">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="shooting-star"></div>
        ))}
      </div>

      <div className="cta-container">
        <motion.div className="cta-main-card" {...getRevealProps('scaleUp')}>
          <div className="card-gloss"></div>

          <div className="cta-left">
            <h2 className="cta-title">Let's build something secure together.</h2>
            <p className="cta-description">
              Whether you need cybersecurity services, managed IT support, or secure software
              development — we respond to every inquiry within one business day. Tell us about
              your needs and we'll connect you with the right specialist.
            </p>
            <div className="cta-primary-actions">
              <Link to="/contact" className="btn-start">Book Consultation</Link>
              <Link to="/services" className="btn-sales">Explore Services</Link>
            </div>
          </div>

          <div className="cta-right">
            <div className="cta-sub-card">
              <div className="sub-card-icon"><FaTag /></div>
              <h3 className="sub-card-title">One partner, every discipline</h3>
              <p className="sub-card-text">
                Cybersecurity, managed IT, and secure software development under one roof —
                no gaps between vendors, no blind spots that attackers can exploit.
              </p>
              <Link to="/services" className="btn-link">
                View all services <FaArrowRight className="arrow-icon" />
              </Link>
            </div>

            <div className="cta-sub-card">
              <div className="sub-card-icon"><FaBolt /></div>
              <h3 className="sub-card-title">Certified expertise, fast response</h3>
              <p className="sub-card-text">
                CISSP, CEH, OSCP, and CISA certified professionals with offices in the United
                Kingdom and India — 24/7 SOC coverage and one business day inquiry response.
              </p>
              <Link to="/contact" className="btn-link">
                Contact our team <FaArrowRight className="arrow-icon" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom Transition Gradient (Black to White) */}
      <div className="cta-bottom-transition"></div>
      
      {/* The Horizon Line - now integrated with the bottom blend */}
      <div className="cta-horizon-glow"></div>
    </ScrollReveal>
  );
};

export default CTASection;
